// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__N7lwj","inner":"Form_inner__1Gd-K","range":"Form_range__249bI","name":"Form_name__1_bPx","actions":"Form_actions__go50G"};